<div class="attachment-list">
  <s2a-attachment *ngFor="let attachmentId of attachments" [file]="attachmentId" [fileIdsList]="attachments"></s2a-attachment>
</div>